"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCT_CONTENT_DATA_BY_TAGS = void 0;
exports.GET_PRODUCT_CONTENT_DATA_BY_TAGS = `
    query ProductDataByTags($tags: [String]) {
        getProductDataByTags(tags: $tags) {
            sku
            title
            subtitle
            tag
            isNew
            tooltip
            defaultSwatch
            category
            hasShopCta
            hasLearnMoreCta
            hasCompareCta
            hasAddToCartCta
            details {
                label
                key
                name
                features
                description
            }
            quickviewSections {
                name
                content
            }
            ardadDescriptors {
                slot
                descriptors
            }
        }
    }
`;
//# sourceMappingURL=queries.js.map